import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const ErrorNotification = ({ error, onClose }) => {
  const getErrorStyle = (error) => {
    if (error.includes('Demasiadas consultas') || error.includes('429')) {
      return {
        bg: 'bg-gradient-to-r from-yellow-500 to-orange-600',
        border: 'border-orange-700',
        icon: '⏱️',
        title: 'Límite de Consultas'
      };
    } else if (error.includes('Parámetros') || error.includes('400')) {
      return {
        bg: 'bg-gradient-to-r from-blue-500 to-blue-600',
        border: 'border-blue-700',
        icon: '🔧',
        title: 'Parámetros Inválidos'
      };
    } else if (error.includes('servidor') || error.includes('500')) {
      return {
        bg: 'bg-gradient-to-r from-purple-500 to-purple-600',
        border: 'border-purple-700',
        icon: '🔧',
        title: 'Error del Servidor'
      };
    } else {
      return {
        bg: 'bg-gradient-to-r from-red-500 to-red-600',
        border: 'border-red-700',
        icon: '⚠️',
        title: 'Error'
      };
    }
  };

  if (!error) return null;

  const style = getErrorStyle(error);

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0, y: -50, scale: 0.95 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        exit={{ opacity: 0, y: -50, scale: 0.95 }}
        className={`text-white p-6 rounded-xl shadow-lg mb-6 border-l-4 ${style.bg} ${style.border}`}
      >
        <div className="flex items-start justify-between">
          <div className="flex items-start gap-3">
            <div className={`p-2 rounded-lg bg-black bg-opacity-20`}>
              <span className="text-xl">{style.icon}</span>
            </div>
            <div>
              <h3 className="font-semibold text-lg">{style.title}</h3>
              <p className="mt-1 opacity-90">{error}</p>
              {error.includes('Demasiadas consultas') && (
                <p className="mt-2 text-sm opacity-80">
                  💡 Espera un momento antes de realizar más búsquedas
                </p>
              )}
            </div>
          </div>
          <button 
            onClick={onClose} 
            className="text-white hover:text-gray-200 text-2xl font-bold transition-colors duration-200 ml-4"
          >
            ×
          </button>
        </div>
      </motion.div>
    </AnimatePresence>
  );
};

export default ErrorNotification;
